/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { useSyncState } from "src/modules/pe-basic-module/hooks/useSyncState"
import { CardsContent, ILandingSection, ITimelineCard, ITimelineDot } from "src/modules/pe-landing-module/data/interfaces"
import { getCssDemention } from "src/libs/utilities/getCssDemention"
import { CSSObjectToString, getCSSValue } from "src/libs/utilities/css"

export interface ITimelineDotProps {
    i:number
    section: ILandingSection
    data: CardsContent
    card: ITimelineCard
    is_two_side: boolean
    shift: number
    amplitude: number
    length: number
    phase: number
    getX: (y:number, i:number) => number
}
export const TimelineDot = ({shift, amplitude, length, phase, is_two_side,  ...props}: ITimelineDotProps) : JSX.Element => { 
    const dots: ITimelineDot = { 
        ...props.data.dots, 
        ...props.card.dots 
    }
    const stroke_width = dots.stroke_width || 0
    const dot_stroke_width = dots.dot_stroke_width || 0
    const perimeter = (dots.perimeter || 0) + dot_stroke_width || 60 
    const odds = ( perimeter - dot_stroke_width - perimeter ) / 2 
    const fontSize  = dots.fontSize || 16
    const round     = getCssDemention( dots.radius )
    const color     = dots.color || "var(--force-contast-color)"
    const fontColor = dots.fontColor || "var(--force-contast-color)"

    const clientHeight  = useSyncState<number>(0)
    const tail          = useSyncState<number>(0)

    useEffect(() => {
        const selector  = `.landing-card-${ props.card.id }`
        const cont      = `.landing-v-timeline-cards-${props.section.id}`
        // TODO :: timeout!!!
        const timeout = setTimeout(() => {
            clientHeight.set( document.querySelector( selector )?.clientHeight || 0 )
            var offsets = document.querySelector( selector )?.getBoundingClientRect() || { top:0, height:0}
            var soffset = document.querySelector( cont )?.getBoundingClientRect() || { top:0, height:0}            
            tail.set(props.i === 0
                ?
                0
                :
                props.i === props.data.cards.length - 1
                    ?
                    clientHeight.get()
                    :
                    0
            )
            const top = Math.floor( offsets.top - soffset.top )  + odds
            const xx = props.getX(top, props.i) + odds 
            
            addCSSClass(
                `landing-v-timeline-dot-${props.section.id}-${props.i}`,
                `.v-timeline-dot-${props.section.id}-${props.i} { 
                    z-index: ${props.i}!important;
                    top: ${ getCssDemention( top ) }!important;
                    ${ `left:  ${ xx }px;` }
                    .coil {
                        width: ${perimeter}px!important;
                        height: ${perimeter}px!important;
                        font-size: ${fontSize}px!important;
                        background-color: ${ color }!important;
                        border-radius: ${ round }!important;
                        border-color: ${ dots.stroke || "var(--force-contrast-color)" };
                        border-style: solid;
                        border-width: ${ getCssDemention( dot_stroke_width ) };
                        color: ${ fontColor }!important; 
                    }
                    .coil:before {
                        content: "";
                        ${ CSSObjectToString( dots.dot_before_style || {} )};
                    }
                    .coil:after {
                        content: "";
                        ${ CSSObjectToString( dots.dot_after_style || {} )};
                    }
                    .dister-- {
                        width: 100px;
                        border-top: 2px solid red;
                        position:absolute;
                        top: ${perimeter/2}px!important;
                        z-index: -1;
                    }
                } 
                `
            ) 
        }, 300)
        
        return () => {
            clearTimeout(timeout)
            removeCSSClass(`landing-v-timeline-dot-${props.section.id}-${props.i}`)
        }
    },[ is_two_side ]) 
    return <div data-i={props.i} className={`v-timiline-dot v-timeline-dot-${props.section.id}-${props.i}`}>
        <div className="dister" />
        <div className="coil" style={dots.dot_style}>
            { !!props.data.dots.significant_zero ?  (props.i + 1).toString().padStart(2, "0") :   props.i + 1 } 
        </div>
    </div>
}